import apiFetch from '../apiFetch'

export default function (token, associatedCostsId) {
  return apiFetch({ endPoint: `AssociatedCostType/${associatedCostsId}`, method: 'GET', body: null, token: token })
}
